import React, { useEffect, useRef, useState } from "react";
import { useLocation } from "react-router-dom";
import "./Contactpage.css";
import { FaPhoneAlt, FaEnvelope } from "react-icons/fa";
import { useForm, ValidationError } from "@formspree/react";
import Footer from "../components/Footer";
import SEO from "../components/SEO";
import { Helmet } from "react-helmet-async";

const Contact = () => {
  const [state, handleSubmit] = useForm("xanrvzee");
  const formRef = useRef(null);
  const location = useLocation();

  const [showSuccess, setShowSuccess] = useState(false);

  const [formValues, setFormValues] = useState({
    subject: "",
    message: "",
  });

  useEffect(() => {
    if (state.succeeded) {
      if (formRef.current) formRef.current.reset();
      setShowSuccess(true);

      const timer = setTimeout(() => {
        setShowSuccess(false);
      }, 5000);

      return () => clearTimeout(timer);
    }
  }, [state.succeeded]);

  useEffect(() => {
    if (location.state && location.state.subject && location.state.message) {
      setFormValues({
        subject: location.state.subject,
        message: location.state.message,
      });
    }
  }, [location.state]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormValues((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  useEffect(() => {
    const card = document.querySelector(".card");
    if (!card) return;

    function revealOnScroll() {
      const rect = card.getBoundingClientRect();
      if (rect.top < window.innerHeight - 100) {
        card.classList.add("visible");
        window.removeEventListener("scroll", revealOnScroll);
      }
    }

    window.addEventListener("scroll", revealOnScroll);
    revealOnScroll();

    return () => window.removeEventListener("scroll", revealOnScroll);
  }, []);

  return (
    <section id="contact-section" className="section">
      <div className="overlay" />
      <div className="inner">
        {/* Left */}
        <div className="left">
          <h5>LET&apos;S WORK TOGETHER</h5>
          <h1>Get In Touch With Car Forensics LTD</h1>

          <div className="item">
            <div className="icon">
              <FaPhoneAlt />
            </div>
            <div className="text">
              <h4>Call Us:</h4>
              <p>
                <a href="tel:+447501911970">+44 7501 911970</a>
              </p>
            </div>
          </div>

          <div className="item">
            <div className="icon">
              <FaEnvelope />
            </div>
            <div className="text">
              <h4>Email Us:</h4>
              <p>
                <a href="mailto:carforensicsltd@gmail.com">
                  carforensicsltd@gmail.com
                </a>
              </p>
            </div>
          </div>
        </div>

        {/* Right */}
        <div className="card">
          <h2>Contact Us</h2>

          {showSuccess ? (
            <div className="success-message">
              <h3>✅ Message Sent Successfully!</h3>
              <p>Thank you for reaching out. We’ll get back to you shortly.</p>
            </div>
          ) : (
            <form onSubmit={handleSubmit} ref={formRef}>
              <div className="form-row">
                <input type="text" name="name" placeholder="Name" required />
                <input type="email" name="email" placeholder="Email" required />
              </div>

              <ValidationError
                prefix="Email"
                field="email"
                errors={state.errors}
                className="error-message"
              />

              <div className="form-row">
                <input
                  type="text"
                  name="number"
                  placeholder="Number"
                  required
                />
                <input
                  type="text"
                  name="subject"
                  placeholder="Subject"
                  value={formValues.subject}
                  onChange={handleInputChange}
                  required
                />
              </div>

              <div className="form-row" style={{ gridTemplateColumns: "1fr" }}>
                <textarea
                  name="message"
                  placeholder="Message"
                  value={formValues.message}
                  onChange={handleInputChange}
                  required
                />
              </div>

              <ValidationError
                prefix="Message"
                field="message"
                errors={state.errors}
                className="error-message"
              />

              <label className="consent">
                <input type="checkbox" required />
                <span>
                  By using this form you agree with the storage and handling of
                  your data by this website.
                </span>
              </label>

              <button type="submit" className="submit" disabled={state.submitting}>
                {state.submitting ? "Sending..." : "SUBMIT"}
              </button>
            </form>
          )}
        </div>
      </div>
    </section>
  );
};

const ContactPage = () => {
  const canonical = "https://carforensic.uk/contact";

  const localBusinessSchema = {
    "@context": "https://schema.org",
    "@type": "AutoRepair",
    "name": "Car Forensics LTD",
    "url": "https://carforensic.uk/",
    "telephone": "+447501911970",
    "email": "carforensicsltd@gmail.com",
    "areaServed": [
      "Kent",
      "Maidstone",
      "Gillingham",
      "Sevenoaks",
      "Sittingbourne"
    ],
    "sameAs": [],
    "image": "https://carforensic.uk/logo3.png",
    "description":
      "Mobile garage services, vehicle diagnostics, ECU services, servicing, tyres and recovery across Kent including Maidstone, Gillingham, Sevenoaks and Sittingbourne."
  };

  return (
    <>
      <SEO
        title="Contact Mobile Mechanic in Kent | Maidstone, Gillingham, Sevenoaks & Sittingbourne"
        description="Contact Car Forensics LTD for mobile auto repair, diagnostics, servicing, ECU services and recovery across Kent. Covering Maidstone, Gillingham, Sevenoaks and Sittingbourne. Call +44 7501 911970."
        canonical={canonical}
      />

      <Helmet>
        <script type="application/ld+json">
          {JSON.stringify(localBusinessSchema)}
        </script>
      </Helmet>

      {/* Banner */}
      <section className="contact-banner">
        <div className="overlay"></div>
        <h1 className="contact-heading">CONTACT US</h1>
      </section>

      <Contact />
      <Footer />
    </>
  );
};

export default ContactPage;
